export { default } from "./NoAccessBanner";
